export const TOSS_ODD_VALUE = 100;
export const BET_TIMEOUT = 20000;
export const EXCH_COMPETITIONS_MENU = 'ExchCompetitionsMenu';
